import * as React from 'react';
import { DESCRIPTION_TOOLTIP } from '../../wording';
import { CardCountIndicator } from '../CardCountIndicator/CardCountIndicator';
import { IDescriptionIndicatorProps } from './types';

export function DescriptionIndicator({
    active,
    onClick
}: IDescriptionIndicatorProps) {
    return (
        <CardCountIndicator
            modificator={'description'}
            active={active}
            icon={'description'}
            tooltip={DESCRIPTION_TOOLTIP}
            onClick={onClick}
        />
    );
}
